/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable dot-notation */
import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import {
  ConfigService,
  DomainService,
  ErroMessages,
  IDomain,
  IErroMessages,
  IRoute,
  RouterItemPg,
  TokenService,
  UserService
} from 'viggo-sistemas-core-web';
import { MenuToolBarItem } from 'viggo-sistemas-core-web/modules/toolbar/components/slide-menu-right/slide-menu-right.component';

import { FastMenuService } from '@app/global services/fast-menu-service/fast-menu.service';
import { DomainOrgService } from '@app/shared/services';
import { ValidadorSettingsDomain } from '@app/shared/utils/validar_settings_domain';

import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmDialogComponent, ConfirmDialogData } from '@app/shared/components';
import { ValidadorSettingsUser } from '@app/shared/utils/validar_settings_user';
import { CustomMenuService } from '../../global services';

interface buildMenu {
  label: string;
  items: RouterItemPg[];
  routerLink?: string[];
  isSubMenu?: boolean;
  icon?: string;
}
@Component({
  selector: 'app-logged',
  templateUrl: './logged.component.html'
})
export class LoggedComponent implements OnDestroy, OnInit {
  // default
  public appName: string;
  public logoToolBar = 'assets/images/icone.png';
  public firstContact = true;
  public showMenu = false;
  public loading = false;
  public empresa: IDomain;
  public requisitions = 0;

  public menuItem = [] as buildMenu[];

  menuFast = [] as MenuToolBarItem[];

  menuProfile = [] as MenuToolBarItem[];
  // primeng

  // actions layout
  topbarMenuActive: boolean;
  menuActive: boolean;
  staticMenuDesktopInactive: boolean;
  mobileMenuActive: boolean;
  menuClick: boolean;
  mobileTopbarActive: boolean;
  topbarRightClick: boolean;
  topbarItemClick: boolean;
  activeTopbarItem: string;
  documentClickListener: () => void;
  configActive: boolean;
  configClick: boolean;
  rightMenuActive: boolean;
  menuHoverActive = false;
  searchClick = false;
  search = false;
  currentInlineMenuKey: string;
  inlineMenuActive: any[] = [];
  inlineMenuClick: boolean;

  // PrimeNG config
  topbarTheme = 'indigo';
  menuTheme = 'light';
  layoutMode = 'light';
  menuMode = 'slim';
  inlineMenuPosition = 'bottom';
  inputStyle = 'filled';
  ripple = true;
  isRTL = false;
  isActive = false;
  itemMenu = false;
  usaFiscal = false;
  usaCaixa = false;
  usaCatalogo = false;
  isUserDefault = false;
  isUserAdmin = false;
  @ViewChild('projectFrame', { read: ElementRef }) projectFrame: ElementRef<
    HTMLDivElement
  >;

  constructor(
    protected menu: CustomMenuService,
    protected fastMenuService: FastMenuService,
    protected domainOrgService: DomainOrgService,
    private matSnackBar: MatSnackBar,
    protected domainService: DomainService,
    protected userService: UserService,
    protected configService: ConfigService,
    private renderer: Renderer2,
    private tokenService: TokenService,
    public matDialog: MatDialog,
    public router: Router,
    public route: ActivatedRoute
  ) {
    this.appName = 'Viggo-Gestor';
    let user = this.tokenService.getUser();
    this.isUserAdmin =
      user.roles.find(rl => rl.name.toUpperCase() === 'ADMIN') !== undefined;
    this.isUserDefault =
      user.roles.find(rl => rl.name.toUpperCase() === 'SYSADMIN') !== undefined;
    user.settings = new ValidadorSettingsUser(
      user.settings,
      this.isUserDefault
    ).getUserSettingsBody(user.settings) as any;
    this.tokenService.refreshUser(user);
  }

  checkIsLoggedIn = (event): void => {
    const element = this.projectFrame?.nativeElement;
    if (element && event && !this.router.url.includes('auth')) {
      if (!this.tokenService.isLoggedIn()) {
        this.matSnackBar.open(
          'Parece que você foi deslogado da plataforma... Acesse novamente!',
          'X',
          {
            duration: 3000,
            panelClass: 'msg-success',
            horizontalPosition: 'right',
            verticalPosition: 'top'
          }
        );
        this.router.navigate(['/auth/login']);
      }
    }
  };

  ngOnInit() {
    this.loading = true;
    window.addEventListener('click', this.checkIsLoggedIn, true);
    const domain = this.tokenService.getDomain();
    domain.settings = new ValidadorSettingsDomain(
      domain.settings
    ).getDomainSettingsBody(domain.settings) as any;
    if (domain.name === 'default') {
      this.requisitions = 0;
      this.firstContact = false;
      this.showMenu = true;
    } else if (
      domain.settings['config_inicial'].ultimo_passo === 'FINALIZADO' ||
      domain.settings['config_inicial'].ultimo_passo === 'FINALIZADO_PARCIAL'
    ) {
      this.requisitions = 0;
      this.firstContact = false;
      this.showMenu = true;
    }
    this.userService.getRoutes().subscribe(routes => {
      this.tokenService.setRoutes(routes);
      this.usaCaixa = this.verificarUsaCaixa();
      this.usaCatalogo = this.verificarUsaCatalogo();
      this.usaFiscal = this.verificarUsaFiscal();
      this.router.events.subscribe((event: NavigationEnd) => {
        this.requisitions += 1;
        if (
          (domain.settings['config_inicial'].ultimo_passo === 'UNKNOWN' ||
            localStorage.getItem('primeiros_passos') === 'true') &&
          (event.url === '/workspace' ||
            event.url === '/' ||
            event.url === '/primeiros_passos') &&
          this.requisitions === 1
        ) {
          this.requisitions = 0;
          this.firstContact = true;
          this.verificarDadosEmpresa();
        } else if (
          domain.settings['config_inicial'].ultimo_passo === 'FINALIZADO' ||
          domain.settings['config_inicial'].ultimo_passo ===
            'FINALIZADO_PARCIAL'
        ) {
          this.requisitions = 0;
          this.firstContact = false;
          this.showMenu = true;
        } else if (event.url === '/erro-integracoes-externas') {
          this.requisitions = 0;
          this.firstContact = false;
          this.showMenu = false;
        }
      });
      this.verificarDadosEmpresa();
    });
  }

  /**
   * Baixa as informações de domain
   */
  protected verificarDadosEmpresa(): void {
    this.domainService
      .getEntity(this.tokenService.getDomain().id, 'application')
      .subscribe(dadosempresa => {
        dadosempresa.settings = new ValidadorSettingsDomain(
          dadosempresa.settings
        ).getDomainSettingsBody(dadosempresa.settings) as any;
        if (
          this.tokenService.getUser().name.includes('sysadmin') ||
          dadosempresa.settings['config_inicial'].ultimo_passo ===
            'FINALIZADO' ||
          ((dadosempresa.settings['config_inicial'].ultimo_passo ===
            'FINALIZADO_PARCIAL' ||
            dadosempresa.settings['config_inicial'].ultimo_passo ===
              'INFO_EMPRESA_REGRAS') &&
            !this.usaFiscal)
        ) {
          this.loading = false;
          this.firstContact = false;
          localStorage.removeItem('UFICMS_ID');
          localStorage.removeItem('primeiros_passos');
          localStorage.removeItem('dialogOpened');
          this.menuActive = !(this.isOverlay() && !this.isMobile());
          if (!this.itemMenu) this.initMenuItem();
        } else {
          localStorage.setItem('primeiros_passos', 'true');
          this.empresa = dadosempresa;
          this.loading = false;
          this.menuProfile = [
            {
              title: 'Informações de usuário',
              icon: 'pi pi-user',
              action: true
            },
            {
              title: 'Alterar senha',
              icon: 'pi pi-lock',
              action: true
            },
            {
              title: 'Sair',
              icon: 'pi pi-power-off',
              action: true
            }
          ] as MenuToolBarItem[];
          this.router.navigate(['primeiros_passos']);
        }
      });
  }

  protected initMenuToolBar() {
    this.menuProfile = [
      {
        title: 'Informações de usuário',
        icon: 'pi pi-user',
        action: true
      },
      {
        title: 'Alterar senha',
        icon: 'pi pi-lock',
        action: true
      },
      {
        title: 'Sair',
        icon: 'pi pi-power-off',
        action: true
      }
    ] as MenuToolBarItem[];
    this.fastMenuService.onCreateFastMenu().subscribe(fastMenuIt => {
      this.menuFast = fastMenuIt;
    });
  }

  /**
   * Verifica as informações fiscais da empresa
   */
  protected verificarDadosFiscais() {
    this.domainOrgService
      .getEntity(this.tokenService.getDomain().id)
      .subscribe(dadosempresa => {
        if (dadosempresa)
          localStorage.setItem('dadosFiscais', JSON.stringify(dadosempresa));
      });
  }

  /**
   * Valida as rotas do usuário
   * @param routes
   * @param url_name
   * @returns
   */
  verificarRotasDeAcesso(routes: IRoute[], url_name: string): IRoute[] {
    if (routes && routes.length > 0 && url_name) {
      return routes.filter(r => new RegExp(`^${url_name}`).test(r.url));
    }
  }

  /**
   * Valida se as rotas do usuário são equivalentes ao pacote de rotas do fiscal
   * @param routesAuthorization
   * @param action
   * @param params
   * @param url_name
   * @returns
   */
  validarAdicao(
    routesAuthorization: IRoute[],
    action: string,
    params = '',
    url_name: string
  ): any {
    if (routesAuthorization && routesAuthorization.length > 0) {
      const url_return = routesAuthorization.find(
        route => route.url === url_name && route.method === action
      );
      return url_return;
    }
  }

  /**
   * Verifica se o dominio usa do módulo caixa ou não
   * @returns
   */
  verificarUsaCaixa() {
    const action = 'POST' as string;
    const params = '' as string;
    const url_caixa_pedido_nfce = '/pedido_nfces' as string;

    const routesAuthorizationCaixa = this.verificarRotasDeAcesso(
      this.tokenService.getRoutes(),
      url_caixa_pedido_nfce
    ) as IRoute[];

    const usaCaixa = this.validarAdicao(
      routesAuthorizationCaixa,
      action,
      params,
      url_caixa_pedido_nfce
    );

    const caixa = usaCaixa !== undefined;
    localStorage.setItem('usaCaixa', caixa.toString());
    return caixa;
  }

  /**
   * Verifica se o dominio usa do módulo caixa ou não
   * @returns
   */
  verificarUsaCatalogo() {
    const action = 'POST' as string;
    const params = '' as string;
    const url_catalogo = '/catalogos' as string;

    const routesAuthorizationCatalogo = this.verificarRotasDeAcesso(
      this.tokenService.getRoutes(),
      url_catalogo
    ) as IRoute[];

    const usaCatalogo = this.validarAdicao(
      routesAuthorizationCatalogo,
      action,
      params,
      url_catalogo
    );
    const catalogo = usaCatalogo !== undefined;
    localStorage.setItem('usaCatalogo', catalogo.toString());
    return catalogo;
  }

  /**
   * Preenhce o usaFiscal no localStorage caso o usuário tenha o pacote NFe
   * @returns
   */
  verificarUsaFiscal() {
    const action = 'POST' as string;
    const params = '' as string;
    const url_nfe = '/nfes' as string;
    const url_nfce = '/nfces' as string;
    // var routesAuthorization: IRoute[] = [];

    const routesAuthorizationNFe = this.verificarRotasDeAcesso(
      this.tokenService.getRoutes(),
      url_nfe
    ) as IRoute[];

    const routesAuthorizationNFCe = this.verificarRotasDeAcesso(
      this.tokenService.getRoutes(),
      url_nfce
    ) as IRoute[];

    const fiscalNFe = this.validarAdicao(
      routesAuthorizationNFe,
      action,
      params,
      url_nfe
    );

    const fiscalNFCe = this.validarAdicao(
      routesAuthorizationNFCe,
      action,
      params,
      url_nfce
    );
    const fiscal = fiscalNFe !== undefined || fiscalNFCe !== undefined;
    const usaNFe = fiscalNFe !== undefined;
    const usaNFCe = fiscalNFCe !== undefined;

    localStorage.setItem('usaFiscal', fiscal ? fiscal.toString() : 'false');

    localStorage.setItem('usaFiscalNFe', usaNFe ? usaNFe.toString() : 'false');

    localStorage.setItem(
      'usaFiscalNFCe',
      usaNFCe ? usaNFCe.toString() : 'false'
    );
    return fiscal;
  }

  protected initMenuItem() {
    this.itemMenu = true;
    // mount menu routes
    this.menu.onCreateMenuPrimeNg().subscribe(menuItem => {
      if (this.usaFiscal) this.verificarDadosFiscais();
      if (!this.isMobile()) {
        const prevMenu = this.menuItem;
        const index = this.menuItem.findIndex(m => m.label.includes('Menu'));
        if (index >= 0) {
          prevMenu.splice(index, 1);
          this.menuItem = prevMenu;
        }
        menuItem.map(item => {
          if (item) {
            this.menuItem.push({
              label: item.label,
              icon: item.icon,
              isSubMenu: item.isSubMenu,
              routerLink: item.routerLink,
              items: item.items
            });
          }
        });
      } else {
        this.menuMode = 'overlay';
        this.menuItem.push({
          label: 'Menu',
          icon: 'pi pi-fw pi-play',
          items: []
        });
        menuItem.map(item => {
          this.menuItem[0].items.push({
            label: item.label,
            icon: item.icon,
            isSubMenu: item.isSubMenu,
            routerLink: item.routerLink,
            items: item.items,
            idElement: item.label
          });
        });
      }
      this.initMenuToolBar();
    });
  }

  ngAfterViewInit() {
    // hides the horizontal submenus or top menu if outside is clicked
    this.documentClickListener = this.renderer.listen('body', 'click', () => {
      if (!this.topbarItemClick) {
        this.activeTopbarItem = null;
        this.topbarMenuActive = false;
      }

      if (!this.menuClick && (this.isHorizontal() || this.isSlim())) {
        this.menu.reset();
      }

      if (this.configActive && !this.configClick) {
        this.configActive = false;
      }

      if (!this.menuClick) {
        if (this.mobileMenuActive) {
          this.mobileMenuActive = false;
        }

        if (this.isOverlay()) {
          this.menuActive = false;
        }

        this.menuHoverActive = false;
        this.unblockBodyScroll();
      }

      if (!this.searchClick) {
        this.search = false;
      }

      if (
        this.inlineMenuActive[this.currentInlineMenuKey] &&
        !this.inlineMenuClick
      ) {
        this.inlineMenuActive[this.currentInlineMenuKey] = false;
      }

      this.inlineMenuClick = false;
      this.searchClick = false;
      this.configClick = false;
      this.topbarItemClick = false;
      this.topbarRightClick = false;
      this.menuClick = false;
    });
  }

  onMenuButtonClick(event) {
    this.menuActive = !this.menuActive;
    this.topbarMenuActive = false;
    this.topbarRightClick = true;
    this.menuClick = true;

    if (this.isDesktop()) {
      this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
    } else {
      this.mobileMenuActive = !this.mobileMenuActive;
      if (this.mobileMenuActive) {
        this.blockBodyScroll();
      } else {
        this.unblockBodyScroll();
      }
    }

    event.preventDefault();
  }

  onTopbarMobileButtonClick(event) {
    this.mobileTopbarActive = !this.mobileTopbarActive;
    event.preventDefault();
  }

  onMenuClick(event) {
    this.menuClick = true;

    if (
      this.inlineMenuActive[this.currentInlineMenuKey] &&
      !this.inlineMenuClick
    ) {
      this.inlineMenuActive[this.currentInlineMenuKey] = false;
    }
  }

  blockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.add('blocked-scroll');
    } else {
      document.body.className += ' blocked-scroll';
    }
  }

  unblockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.remove('blocked-scroll');
    } else {
      document.body.className = document.body.className.replace(
        new RegExp(
          `(^|\\b)${'blocked-scroll'.split(' ').join('|')}(\\b|$)`,
          'gi'
        ),
        ' '
      );
    }
  }

  isDesktop() {
    return window.innerWidth > 991;
  }

  isMobile() {
    return window.innerWidth <= 1366;
  }

  isStatic() {
    return this.menuMode === 'static';
  }

  isHorizontal() {
    return this.menuMode === 'horizontal';
  }

  isSlim() {
    return this.menuMode === 'slim';
  }

  isOverlay() {
    return this.menuMode === 'overlay';
  }

  ngOnDestroy() {
    // window.removeEventListener('click', this.checkIsLoggedIn, true);
    if (this.documentClickListener) {
      this.documentClickListener();
    }
  }

  get isLoggedIn() {
    return this.tokenService.isLoggedIn();
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const txtMsg = showDefaultMsg
      ? `Identificamos o erro ${err.status} - ${err.statusText} no processamento dos dados!`
      : err.error;
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      matDialog: this.matDialog,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      vlMsgDefault: txtMsg,
      dialogComponent: ConfirmDialogComponent,
      dialogData: {
        config: {
          data: {
            title: 'Aviso',
            icon: 'warning',
            bodyMessage: txtMsg,
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          width: '500px'
        }
      }
    } as IErroMessages);
    errorMsg.showMessageObject(txtMsg);
    // errorMsg.checkError();
  }

}
